
import {
  Component, Prop, Watch, Mixins,
} from 'vue-property-decorator';
import moment from 'moment';
import {
  BoxStatusType, AttachmentType,
  Lead, Task,
} from '@/types';
import { getLeadCustomValueDate, getLeadCustomValueText } from '@/helpers';
import BoxStatus from '@/components/BoxStatus.vue';
import AttachmentsList from '@/components/AttachmentsList.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import AttachmentWithStatus from '@/components/AttachmentWithStatus.vue';

moment.locale('it');

@Component({
  components: {
    BoxStatus,
    AttachmentsList,
    AttachmentWithStatus,
  },
})

export default class EditCheckZonaVincoloDialog extends Mixins(UtilsMixin) {
  @Prop(Boolean) readonly value!: boolean;

  @Prop(Object) readonly task: Task | undefined;

  // Utilizza il dialog all'interno di una Connection
  @Prop({ type: Boolean, default: false }) readonly connection!: boolean;

  checkZonaVincolo: BoxStatusType | null = 'todo'
  checkZonaVincoloLastUpdate: Date | null = null
  checkZonaVincoloUpdater: string | null = null
  checkZonaVincoloNotes: string | null = null

  autodichiarazioneCliente: BoxStatusType | null = 'todo'
  autodichiarazioneClienteNotes: string | null = null

  dialog = false
  valid = false
  loading = false

  get checkZonaVincoloTooltip(): string | null | undefined {
    return this.checkZonaVincoloLastUpdate
      ? `${moment(this.checkZonaVincoloLastUpdate).format('DD/MM/YYYY HH:mm')} - ${this.checkZonaVincoloUpdater}`
      : 'Nessuna modifica effettuata';
  }

  @Watch('value')
  async onValueChange(val: boolean) {
    console.log(`${this.constructor.name}: onValueChange(${val})`); // eslint-disable-line no-console

    // Se il dialog è stato aperto...
    if (val === true) {
      // Recupera le informazioni sul Check Zona di Vincolo se l'utente ha i permessi necessari
      if (this.hasPermission('taskcm.checkZonaVincolo.show')) {
        if (this.connection) {
          // Connection
          console.log(`${this.constructor.name}: onValueChange(${val}) - recupero le informazioni sul Check Zona di Vincolo (Connection)`); // eslint-disable-line no-console

          const currentLead = this.$store.getters.currentLead as Lead | null;

          this.checkZonaVincolo = (getLeadCustomValueText(currentLead, 'checkZonaVincolo') ?? 'todo') as BoxStatusType;
          this.checkZonaVincoloLastUpdate = getLeadCustomValueDate(currentLead, 'checkZonaVincoloLastUpdate');
          this.checkZonaVincoloUpdater = getLeadCustomValueText(currentLead, 'checkZonaVincoloUpdater');
          this.checkZonaVincoloNotes = getLeadCustomValueText(currentLead, 'checkZonaVincoloNotes');
        } else {
          // Task
          console.log(`${this.constructor.name}: onValueChange(${val}) - recupero le informazioni sul Check Zona di Vincolo (Task)`); // eslint-disable-line no-console

          // Recupero la lead padre
          const currentFather = this.$store.getters.currentFather as Lead | null;

          this.checkZonaVincolo = (getLeadCustomValueText(currentFather, 'checkZonaVincolo') ?? 'todo') as BoxStatusType;
          this.checkZonaVincoloLastUpdate = getLeadCustomValueDate(currentFather, 'checkZonaVincoloLastUpdate');
          this.checkZonaVincoloUpdater = getLeadCustomValueText(currentFather, 'checkZonaVincoloUpdater');
          this.checkZonaVincoloNotes = getLeadCustomValueText(currentFather, 'checkZonaVincoloNotes');
        }
      }

      // Recupera le informazioni sull'Autodichiarazione Cliente se l'utente ha i permessi necessari
      if (this.hasPermission('taskcm.autodichiarazioneCliente.show')) {
        if (this.connection) {
          // L'utente ha aperto il dialog da una Connection
          // I custom values sono salvati nella lead corrente
          console.log(`${this.constructor.name}: onValueChange(${val}) - recupero le informazioni sull'Autodichiarazione Cliente (Connection)`); // eslint-disable-line no-console

          const currentLead = this.$store.getters.currentLead as Lead | null;

          this.autodichiarazioneCliente = (getLeadCustomValueText(currentLead, 'autodichiarazioneCliente') ?? 'todo') as BoxStatusType;
          this.autodichiarazioneClienteNotes = getLeadCustomValueText(currentLead, 'autodichiarazioneClienteNotes');
        } else {
          // L'utente ha aperto il dialog da un Task
          // I custom values sono salvati nella lead padre
          console.log(`${this.constructor.name}: onValueChange(${val}) - recupero le informazioni sull'Autodichiarazione Cliente (Task)`); // eslint-disable-line no-console

          const currentFather = this.$store.getters.currentFather as Lead | null;

          this.autodichiarazioneCliente = (getLeadCustomValueText(currentFather, 'autodichiarazioneCliente') ?? 'todo') as BoxStatusType;
          this.autodichiarazioneClienteNotes = getLeadCustomValueText(currentFather, 'autodichiarazioneClienteNotes');
        }
      }
    }

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    console.log(`${this.constructor.name}: onDialogChange(${val})`); // eslint-disable-line no-console

    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  @Watch('checkZonaVincolo')
  onCheckZonaVincoloChange(val: BoxStatusType, oldVal: BoxStatusType) {
    console.log(`${this.constructor.name}: onCheckZonaVincoloChange(${val})`); // eslint-disable-line no-console

    // Se lo stato è cambiato...
    if (val !== oldVal) {
      // ... aggiorna la data e l'utente che ha effettuato l'ultima modifica
      this.checkZonaVincoloLastUpdate = new Date();
      this.checkZonaVincoloUpdater = this.$store.getters.currentUser.name;
    }
  }

  get title(): string {
    if (this.hasPermission('taskcm.checkZonaVincolo.show')
      && !this.hasPermission('taskcm.autodichiarazioneCliente.show')) {
      return 'Check zona di vincolo';
    }

    if (!this.hasPermission('taskcm.checkZonaVincolo.show')
      && this.hasPermission('taskcm.autodichiarazioneCliente.show')) {
      return 'Autodichiarazione Cliente Titolo Aut./Edilizia Libera/VVF/ecc.';
    }

    return 'Check zona di vincolo, autodichiarazione ClienteTitolo Aut./Edilizia Libera/VVF/ecc.';
  }

  updateAttachmentStatus(type: AttachmentType, status: BoxStatusType) {
    console.log(`${this.constructor.name}: updateAttachmentStatus(${type}, ${status})`); // eslint-disable-line no-console

    // Se lo stato non è uno di quelli gestiti, si ferma subito
    if (type in this === false) { return; }

    (this[type] as BoxStatusType) = status;

    const update = {} as { [key: string]: unknown };

    update[type] = status;
  }

  async onClose() {
    console.log(`${this.constructor.name}: onClose()`); // eslint-disable-line no-console

    this.loading = true;

    // Prepara l'aggiornamento
    const update = {} as { [key: string]: unknown };
    update.checkZonaVincolo = this.checkZonaVincolo;
    update.checkZonaVincoloNotes = this.checkZonaVincoloNotes;
    update.autodichiarazioneCliente = this.autodichiarazioneCliente;
    update.autodichiarazioneClienteNotes = this.autodichiarazioneClienteNotes;
    console.log(`${this.constructor.name}: update =`, update); // eslint-disable-line no-console

    // Invia i dati aggiornati a chi ha aperto il dialog
    this.$emit('update', update);

    // Chiude il dialog e disattiva l'indicatore di caricamento
    this.dialog = false;
    setTimeout(() => { this.loading = false; }, 500);
  }
}
